//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["action","objTags"],"RemoveAttributes",{},2,0]],[]];
SPLM.PcbExchange.AttributeRemover = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.AttributeRemover";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.AttributeRemover.Option = Object.freeze({
    "Board" : "Board", "Components" : "Components", "Areas" : "Areas", "Holes" : "Holes", "Traces" : "Traces", "Pads" : "Pads", "All" : "All"});

export default SPLM;